/**
 * Reactive state for the live streaming toggle.
 *
 * This is intentionally NOT persisted — it resets to false on every session/page load.
 * The user must explicitly enable streaming each session.
 */
import { selectedRoaster, session } from '$lib/PersistedState.svelte';
import logger from '$lib/logger';
import { liveStream } from './LiveStream';

class StreamingState {
  #enabled = $state(false);

  get enabled(): boolean {
    return this.#enabled;
  }

  set enabled(value: boolean) {
    this.#enabled = value;
    logger.info('Live streaming toggled', { enabled: value });

    if (value) {
      this.#connectIfReady();
    } else {
      liveStream.disconnect();
    }
  }

  /** Called when the device connects/disconnects. Respects the toggle state. */
  onDeviceConnectionChange(isConnected: boolean) {
    if (isConnected && this.#enabled) {
      this.#connectIfReady();
    } else if (!isConnected && liveStream.isConnected) {
      liveStream.disconnect();
    }
  }

  #connectIfReady() {
    if (selectedRoaster.roasterId && session.token) {
      liveStream.connect(selectedRoaster.roasterId, session.token);
    }
  }

  reset() {
    this.#enabled = false;
    liveStream.disconnect();
  }
}

export const streamingState = new StreamingState();
